import moment from 'moment'
import Vue from 'vue'
export default {
  securityToken: function(state) {
    return 'BEARER ' + state.userid + ' ' + state.accessToken
  },
  isLoading: function(state) {
    return state.loading
  },
  isLoggedIn: function(state) {
    return state.isLoggedIn
  },
  unsubscribedPage: function(state) {
    let pagelist = []
    if (state.pagelist) {
      state.pagelist.map(function(pageValue, pageIndex) {
        let isFound = false
        if (state.botlist) {
          state.botlist.map(function(botValue, botIndex) {
            if (botValue.pageid === pageValue.id) {
              isFound = true
              return false
            }
          })
        }

        if (!isFound) {
          pagelist.push(pageValue)
        }
      })
    }

    return pagelist
  },
  allPage: function(state) {
    let pagelist = []

    if (state.pagelist) {
      state.pagelist.map(function(pageValue, pageIndex) {
        let isFound = false
        if (state.botlist) {
          state.botlist.map(function(botValue, botIndex) {
            if (botValue.pageid === pageValue.id) {
              isFound = true
              return false
            }
          })
        }

        pageValue.isInstallBot = isFound
        pagelist.push(pageValue)
      })
    }

    return pagelist
  },
  selectedBot: function(state) {
    if (state.selectedBot == null) {
      return null
    }
    var selectedBot = state.selectedBot
    // selectedBot.ketshop_api_key = 'aaa'
    // selectedBot.ketshop_api_secret = 'aaa'
    return selectedBot
  },
  botlist: function(state) {
    return state.botlist
  },
  isSelectedBot: function(state) {
    return state.isSelectedBot
  },
  paypalTrackingId: function(state) {
    return state.paypalTrackingId
  },
  setting: function(state) {
    return state.setting
  },
  welcomeMessage: function(state) {
    return state.welcomeMessage
  },
  welcomeMessage: (state, getters) => type => {
    var welcome_intent = getters.getIntents('welcome')
    let multichannel_welcome = false
    if (welcome_intent && welcome_intent.length > 0) {
      const hasMultipleChannel = state.socialChannelOptions.find(social => {
        return (
          Object.prototype.hasOwnProperty.call(welcome_intent[0], `${social.value}_val`) &&
          welcome_intent[0][`${social.value}_val`]
        )
      })

      if (hasMultipleChannel) {
        if (state.socialChannelOptions.some(social => social.value == type)) {
          try {
            multichannel_welcome = JSON.parse(welcome_intent[0][`${type}_val`])
          } catch (error) {
            console.error(error)
          }
        }
      }
    }
    if (multichannel_welcome) {
      return {
        multichannel: multichannel_welcome != false,
        messages: multichannel_welcome
      }
    }
    return {
      multichannel: false,
      messages:
        state.welcomeMessage && state.welcomeMessage.messages ? state.welcomeMessage.messages : [[]]
    }
  },
  getIntents: state => type => {
    if (!state.intents) {
      return []
    }
    if (type) {
      switch (type) {
        case 'intent':
          return state.intents.filter(el => {
            return (
              el.context_in != 'comment' &&
              !['{welcome}', '{default}', '{default_comment_to_inbox}', '{default_live}'].includes(
                el.intentname
              )
            )
          })
        case 'comment':
          return state.intents.filter(el => {
            return (
              el.context_in == 'comment' &&
              !['{welcome}', '{default}', '{default_comment_to_inbox}', '{default_live}'].includes(
                el.intentname
              )
            )
          })
        default:
          return state.intents.filter(el => {
            return el.intentname == `{${type}}`
          })
      }
    } else {
      return state.intents
    }
  },
  showModalWelcome: function(state) {
    return state.showModalWelcome
  },
  isFacebook: function(state) {
    return state.isFacebook
  },
  isCoachlab: function(state) {
    return state.selectedBot.pagetype == 'coachlab'
  },
  getPackage: function(state) {
    var now = moment()
    if (!state.selectedBot) {
      return 'normal'
    }
    var date = moment(state.selectedBot.expireat)
    var expriedTime = parseInt(date.diff(now, 'seconds'))
    return expriedTime > 0 ? 'premium' : 'normal'
  },
  currentLang: function(state) {
    return Vue.i18n.locale()
  },
  showAlert: state => type => {
    if (!state.selectedBot) {
      return -1
    }
    return state.alert.findIndex(function(el) {
      return el.name === type && el.pageid === state.selectedBot.pageid
    })
  },
  getCategories: function(state) {
    return state.ecommerce.categories
  },
  getLoadingCategory: function(state) {
    return state.ecommerce.loadingCategory
  },
  getProducts: function(state) {
    return state.ecommerce.products
  },
  getLoadingProduct: function(state) {
    return state.ecommerce.loadingProduct
  },
  getUserStatus: function(state) {
    return state.userStatus
  },
  getLoadingUserStatus: function(state) {
    return state.loadingUserStatus
  },
  getLoadingSetting: function(state) {
    return state.loadingSetting
  },
  getSetting: function(state) {
    return state.setting
  },
  getLoadingCharges: function(state) {
    return state.ecommerce.loadingCharges
  },
  getCharges: function(state) {
    return state.ecommerce.charges
  },
  getLivechatUsers: function(state) {
    return type => {
      if (state.livechat && state.livechat.userlist[type]) {
        return state.livechat.userlist[type].users
      } else {
        return []
      }
    }
  },
  getCurrentUser: function(state) {
    return state.livechat.currentUser
  },
  allSchools: function(state) {
    return state.allSchools
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js